import { Matrix4 } from 'three'
import toQuaternion from './conversion/toQuaternion'
import { toVector3 } from './conversion/toVector3'

export default function decomposeMatrix(m: Matrix4) {
  const position = toVector3()
  const rotation = toQuaternion()
  const scale = toVector3()
  m.decompose(position, rotation, scale)
  return { position, rotation, scale }
}
